import { UPDATE_OBJECT, SET_VISIBILITY } from "../constants/action-types";

export function updateObject(payload) {
  return { type: UPDATE_OBJECT, payload };
}

export function setVisibilityFilter(filter) {
  return { type: SET_VISIBILITY, filter }
}